export default __webpack_public_path__ + "0217f9e6dff98d4f2e6d26e4c8ee4485.png";